import { render, staticRenderFns } from "./PaymentMethodSettingsTable.vue?vue&type=template&id=69464c2d"
import script from "./PaymentMethodSettingsTable.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSettingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports